/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// This is an approximation of the start of the session
const sessionStart = Date.now();

/**
 * Memory usage report.
 *
 * In the future may be extended to contain `performance.measureUserAgentSpecificMemory` if Jira
 * front-end uses cross-origin isolation.
 */
export type MemoryUsageReport = {
	// Approximate time in SPA
	sessionTime: number;
	// performance.memory entry
	performanceMemoryEntry: {
		jsHeapSizeLimit: number;
		totalJSHeapSize: number;
		usedJSHeapSize: number;
	};
};

/**
 * Read from `performance.memory` if available and return the result as a plain object.
 */
export const getMemoryUsageReport = (): MemoryUsageReport | null => {
	// @ts-expect-error - TS2339 - Property 'memory' does not exist on type 'Performance'.
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	if (typeof performance === 'undefined' || performance?.memory == null) {
		return null;
	}

	const now = Date.now();
	const sessionTime = now - sessionStart;
	// @ts-expect-error - TS2339 - Property 'memory' does not exist on type 'Performance'.
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	const { jsHeapSizeLimit, totalJSHeapSize, usedJSHeapSize } = performance.memory;

	return {
		sessionTime,
		performanceMemoryEntry: {
			jsHeapSizeLimit,
			totalJSHeapSize,
			usedJSHeapSize,
		},
	};
};
